/**
 * The display text of an ots-data `LocalizedString` without requiring an IntlProvider above the
 * component -- shared components are mounted into GWT and other hosts that may not provide one.
 */
export const toDisplayText = (value?: string | {defaultMessage?: string} | null): string | undefined => {
  if (value == null) {
    return undefined;
  }

  return typeof value === "string" ? value : value.defaultMessage;
};
